import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://127.0.0.1:8000/api/v1';

// Create axios instance
const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

// Request interceptor - Add token to headers
apiClient.interceptors.request.use(
  (config) => {
    try {
      const token = localStorage.getItem('token');
      if (token && token !== 'undefined' && token !== 'null' && token.trim() !== '' && config.headers) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (error) {
      console.warn('Failed to read token from localStorage:', error);
    }
    
    // If data is FormData, let axios set Content-Type automatically with boundary
    if (config.data instanceof FormData) {
      if (config.headers) {
        delete config.headers['Content-Type'];
        delete config.headers['Accept'];
      }
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - Handle errors globally
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      // Handle 401 Unauthorized - redirect to login
      if (error.response.status === 401) {
        try {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
        } catch (e) {
          console.warn('Failed to clear localStorage:', e);
        }
        window.location.href = '/login';
      }

      // Handle validation errors (422)
      if (error.response.status === 422 && error.response.data.errors) {
        return Promise.reject(error.response.data);
      }

      // Handle other errors
      const apiError = {
        message: error.response.data?.message || 'An error occurred',
        errors: error.response.data?.errors,
      };
      return Promise.reject(apiError);
    }

    // Network error
    return Promise.reject({
      message: 'Network error. Please check your connection.',
    });
  }
);

export default apiClient;




